import { generateColumnsDefaultConfiguration } from "../../../../../components/dataGrid/columnHelpers";

export function useTabIndicacionHistorialColumns() {
  const initialColumns = [
    {
      flex: 1.5,
      field: "idEvaluacion",
      headerName: "Contrato",
    },
    {
      flex: 1.3,
      field: "idIndicacion",
      headerName: "Indicación",
    },
    {
      flex: 2,
      field: "fechaDesde",
      headerName: "Fecha desde",
      type: "date",
    },
    {
      flex: 2,
      field: "fechaHasta",
      headerName: "Fecha hasta",
      type: "date",
    },
    {
      flex: 3.5,
      field: "insumo",
      headerName: "Insumo",
    },
    {
      flex: 1.5,
      field: "cantidad",
      headerName: "Cantidad",
    },
    {
      flex: 1.5,
      field: "unidad",
      headerName: "Unidad",
      type: "select",
    },
  ];

  const columns = generateColumnsDefaultConfiguration(initialColumns, true);

  return columns;
}
